
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'billing-portal-ui',
  currentProjectVersion: 'static-1.752',
  depVersions: {
  "billing-portal-ui": "static-1.752",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.443",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7742",
  "hub-http-shared-msw-handlers": "static-1.9332",
  "hubspot-dlb": "static-2.1786",
  "react-dlb": "static-1.70",
  "billing-portal-service-types": "static-1.590",
  "data-fetching-client": "static-1.9418",
  "foundations-assets": "static-1.4573",
  "foundations-components": "static-1.7407",
  "hub-http": "static-1.5872",
  "HubStyleTokens": "static-2.11163",
  "I18n": "static-7.1554",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.472",
  "quartz-config": "static-1.426",
  "quartz-core": "static-1.5867",
  "quick-fetch": "static-1.3677",
  "react": "static-7.176",
  "react-dom": "static-7.85",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16381",
  "react-router-dom": "static-5.26",
  "redux": "static-4.16",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4369",
  "ui-addon-iframeable": "static-1.8777",
  "ui-addon-react-router-dom": "static-1.9288",
  "UIComponents": "static-3.8110",
  "usage-tracker": "static-1.7075",
  "usage-tracker-anonymous": "static-1.5492",
  "usage-tracker-core": "static-1.6925",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3873",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9346",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3174",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2925",
  "quartz-webpack": "static-1.2872",
  "HeadJS": "static-2.700",
  "quartz": "static-1.6648",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2853",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3852",
  "webpack-env": "static-1.54",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "foundations-theming": "static-1.4149",
  "bend-plugin-foundations-components": "static-1.3676",
  "floating-ui": "static-1.50",
  "foundations-theming-specialty": "static-1.1865",
  "hs-story-utils": "static-1.9168",
  "react-aria": "static-1.60",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5122",
  "react-virtualized": "static-2.93",
  "StyleGuideUI": "static-3.482",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1051",
  "ui-fonts": "static-1.425",
  "ui-images": "static-2.1074",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "foundations-theming-base": "static-1.3134",
  "js-cookie": "static-1.18",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "history": "static-4.47",
  "hub-http-janus": "static-1.782",
  "hubspotter-http": "static-1.4426",
  "icons": "static-2.618",
  "jasmine": "static-4.4072",
  "jasmine-runner": "static-1.6212",
  "mobile-manifest-mixins": "static-1.473",
  "quartz-auth": "static-1.323",
  "quartz-head": "static-1.313",
  "quartz-i18n": "static-1.323",
  "quartz-routing": "static-1.78",
  "quartz-test": "static-1.323",
  "usage-tracker-container": "static-1.7065",
  "csstype": "static-1.50",
  "immer": "static-1.33",
  "redux-thunk": "static-2.43",
  "magpie-lib": "static-1.5331",
  "navigation-messaging": "static-1.6420",
  "cssUtils": "static-1.714",
  "HubStyle": "static-2.11471",
  "bender-build-tools": "static-1.2867",
  "bend-plugin-foundations-theming": "static-1.2632",
  "stylex": "static-1.26",
  "react-input-autosize": "static-2.17",
  "sassPrefix": "static-1.150",
  "hubspotter-http-shared-msw-handlers": "static-1.9330",
  "idb-keyval": "static-1.38",
  "magpie-types": "static-1.4791",
  "reactive-lib": "static-1.467",
  "simple-logging-lib": "static-1.2792"
},
  depPathPrefixes: {
  "billing-portal-ui": "/billing-portal-ui/static-1.752",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.443",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7742",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9332",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "react-dlb": "/react-dlb/static-1.70",
  "billing-portal-service-types": "/billing-portal-service-types/static-1.590",
  "data-fetching-client": "/data-fetching-client/static-1.9418",
  "foundations-assets": "/foundations-assets/static-1.4573",
  "foundations-components": "/foundations-components/static-1.7407",
  "hub-http": "/hub-http/static-1.5872",
  "HubStyleTokens": "/HubStyleTokens/static-2.11163",
  "I18n": "/I18n/static-7.1554",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.472",
  "quartz-config": "/quartz-config/static-1.426",
  "quartz-core": "/quartz-core/static-1.5867",
  "quick-fetch": "/quick-fetch/static-1.3677",
  "react": "/react/static-7.176",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16381",
  "react-router-dom": "/react-router-dom/static-5.26",
  "redux": "/redux/static-4.16",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4369",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8777",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9288",
  "UIComponents": "/UIComponents/static-3.8110",
  "usage-tracker": "/usage-tracker/static-1.7075",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5492",
  "usage-tracker-core": "/usage-tracker-core/static-1.6925",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9346",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3174",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2925",
  "quartz-webpack": "/quartz-webpack/static-1.2872",
  "HeadJS": "/HeadJS/static-2.700",
  "quartz": "/quartz/static-1.6648",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2853",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3852",
  "webpack-env": "/webpack-env/static-1.54",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "foundations-theming": "/foundations-theming/static-1.4149",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3676",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1865",
  "hs-story-utils": "/hs-story-utils/static-1.9168",
  "react-aria": "/react-aria/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5122",
  "react-virtualized": "/react-virtualized/static-2.93",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1051",
  "ui-fonts": "/ui-fonts/static-1.425",
  "ui-images": "/ui-images/static-2.1074",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "foundations-theming-base": "/foundations-theming-base/static-1.3134",
  "js-cookie": "/js-cookie/static-1.18",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "history": "/history/static-4.47",
  "hub-http-janus": "/hub-http-janus/static-1.782",
  "hubspotter-http": "/hubspotter-http/static-1.4426",
  "icons": "/icons/static-2.618",
  "jasmine": "/jasmine/static-4.4072",
  "jasmine-runner": "/jasmine-runner/static-1.6212",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.473",
  "quartz-auth": "/quartz-auth/static-1.323",
  "quartz-head": "/quartz-head/static-1.313",
  "quartz-i18n": "/quartz-i18n/static-1.323",
  "quartz-routing": "/quartz-routing/static-1.78",
  "quartz-test": "/quartz-test/static-1.323",
  "usage-tracker-container": "/usage-tracker-container/static-1.7065",
  "csstype": "/csstype/static-1.50",
  "immer": "/immer/static-1.33",
  "redux-thunk": "/redux-thunk/static-2.43",
  "magpie-lib": "/magpie-lib/static-1.5331",
  "navigation-messaging": "/navigation-messaging/static-1.6420",
  "cssUtils": "/cssUtils/static-1.714",
  "HubStyle": "/HubStyle/static-2.11471",
  "bender-build-tools": "/bender-build-tools/static-1.2867",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2632",
  "stylex": "/stylex/static-1.26",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "sassPrefix": "/sassPrefix/static-1.150",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9330",
  "idb-keyval": "/idb-keyval/static-1.38",
  "magpie-types": "/magpie-types/static-1.4791",
  "reactive-lib": "/reactive-lib/static-1.467",
  "simple-logging-lib": "/simple-logging-lib/static-1.2792"
}
};
